import projectOne from '../../assets/images/project-1.jpeg';
import projectTwo from '../../assets/images/project-2.png';
import projectThree from '../../assets/images/project-3.png';
import projectFour from '../../assets/images/project-4.jpeg';
import projectFive from '../../assets/images/project-5.jpeg';
import media  from '../../assets/videos/media';

export const projectsData = [
  {
    id: 1,
    title: "Home Renovation",
    category: "Residential",
    type: "image",
    size: "large",
    image: projectOne,
    desc: "Details about home renovation!",
    client: 'Placeholder',
    year: 2024
  },
  {
    id: 2,
    title: "Interior Walkthrough",
    category: "Interior",
    type: "video",
    size: "tall",
    image: projectTwo,
    videoSrc: media.projectVideoOne,
    desc: "A cinematic tour through our latest interior design project, highlighting custom finishes.",
    client: 'Modern Living',
    year: 2024
  },
  {
    id: 3,
    title: "Fireplace Installation",
    category: "Interior",
    type: "image",
    size: "normal",
    image: projectFour,
    desc: "Beautiful new fireplace installed in home.",
    client: 'ME',
    year: 2025
  },
  {
    id: 4,
    title: "Lakehouse Renovation",
    category: "Interior",
    type: "video",
    size: "normal",
    videoSrc: media.projectVideoTwo,
    image: projectThree,
    desc: "Luxury installation consulting.",
    client: 'Placeholder',
    year: 2000
  },
  {
    id: 5,
    title: "Desert Oasis Villa",
    category: "Residential",
    type: "image",
    size: "wide",
    image: projectFive,
    desc: "Landscape and structural integration.",
    client: 'Placeholder',
    year: 2000
  },
];